/**
 * AuthLayout — centered auth column (max-width) on all viewports; shared shell for login, MFA, etc.
 * @viewport both
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container } from '@mui/material';
import Footer from '@/components/common/Footer';
import { ZINDEX } from '@/core/platform/platformStandards';

/** Readable form line length; keeps fields from stretching edge-to-edge on tablets. */
const AUTH_FORM_MAX_WIDTH_PX = 440;

const AuthLayout = ({ children }) => (
  <Box
    sx={{
      height: '100dvh',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: 'background.default',
      position: 'relative',
    }}
  >
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        position: 'relative',
        zIndex: ZINDEX.raised,
        minHeight: 0,
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          height: '100%',
          px: { xs: 2, sm: 3 },
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: { xs: 2, md: 4 },
            overflow: 'auto',
            width: '100%',
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: AUTH_FORM_MAX_WIDTH_PX,
              mx: 'auto',
              minWidth: 0,
              bgcolor: 'background.paper',
              p: { xs: 2, md: 4 },
            }}
          >
            {children}
          </Box>
        </Box>
      </Container>
    </Box>

    <Footer />
  </Box>
);

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AuthLayout;
